// Returns true if the chart type has axes in the style of a column chart.
export function isVerticalType(type) {
  return type === 'line' ||
    type === 'column' ||
    type === 'area';
}


// Convenience utility function for looping through the ticks on an axis,
// which is necessary a million times in this module.
export function forAxisTicks(axis, callback) {
  for (let i = 0; i < axis.tickPositions.length; i++) {
    let tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}

// Like forAxisTicks() but runs in reverse (index high to low).
export function forAxisTicksReverse(axis, callback) {
  for (let i = axis.tickPositions.length - 1; i >= 0; i--) {
    let tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/util.js